import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { riepilogoPromemoria } from './promemoriaScadenze';

const useStyles = makeStyles((theme) => ({
  riepilogo: {
    color: theme.palette.text.secondary,
    textAlign: 'right',
    margin: theme.spacing(1, 0),
  },
}));

/** The summary line under the Documenti toolbar; nothing with the service off. */
const RiepilogoPromemoria = ({ configurazione }) => {
  const classes = useStyles();
  const testo = riepilogoPromemoria(configurazione);
  if (!testo) {
    return null;
  }
  return (
    <Typography variant="body2" component="p" className={classes.riepilogo}>
      {testo}
    </Typography>
  );
};

RiepilogoPromemoria.propTypes = {
  configurazione: PropTypes.shape({
    attivo: PropTypes.bool.isRequired,
    preavvisi: PropTypes.arrayOf(PropTypes.number).isRequired,
    destinatari: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
};

RiepilogoPromemoria.defaultProps = {
  configurazione: null,
};

export default RiepilogoPromemoria;
